/**
 * Where the portal's legal pages live.
 *
 * Named here rather than written into each footer because there are two
 * footers — the signed-out shell and the app shell — and three links, and a
 * URL repeated five times is a URL that gets updated in four places.
 *
 * They are metricsiq.ai pages rather than pages this service serves. That is a
 * deliberate consequence of where the documents already exist, not a decision
 * this module is making: it names destinations, and if they ever move into the
 * product these constants are the one place that changes.
 *
 * `TERMS` POINTS AT THE EULA, NOT THE WEBSITE TERMS OF USE, and the
 * distinction is the reason this constant exists rather than a literal.
 * metricsiq.ai carries both: a "Website Terms of Use" that says in its own
 * words "These Terms apply only to your use of this website", and the AWS
 * Marketplace End User License Agreement, which governs "Customer's access to
 * and use of the mDecide Platform" and incorporates the Data Processing
 * Addendum as Exhibit A.
 *
 * This portal is not the website. A person reading it is managing a paid
 * subscription bought through a sales channel, so a link labelled "Terms" here
 * has to reach the agreement governing that subscription. For a while it
 * reached neither — the anchors shipped as `href="#"` — and then briefly the
 * website terms, which was closer but still wrong.
 *
 * THE EULA IS CHANNEL-SPECIFIC, by its own title and text: it governs
 * subscriptions bought through AWS Marketplace. That is every customer today,
 * because Marketplace is the only channel with an adapter. It stops being true
 * the day a second channel lands, and at that point this link has to be
 * derived per subscription the way `invoicedBy` already derives its wording —
 * a constant will no longer do.
 */
export const LEGAL = {
  privacy: 'https://www.metricsiq.ai/legal/privacy-policy/',
  terms: 'https://www.metricsiq.ai/legal/eula/',
  cookies: 'https://www.metricsiq.ai/legal/cookie-policy/',
} as const;
